module.exports = __webpack_public_path__ + "static/media/footer-graphic-2x.65fb147a.png";